import type { ArtistApplicationSearchRequest } from "../types";

const artistApplicationKeys = {
  base: ["artistApplications"] as const,
  lists: () => [...artistApplicationKeys.base, "list"] as const,
  list: (request?: ArtistApplicationSearchRequest) =>
    [...artistApplicationKeys.lists(), request] as const,
  details: () => [...artistApplicationKeys.base, "detail"] as const,
  detail: (applicationId?: string) =>
    [...artistApplicationKeys.details(), applicationId] as const,
};

const projectApplicationKeys = {
  base: ["projectApplications"] as const,
  lists: () => [...projectApplicationKeys.base, "list"] as const,
  details: () => [...projectApplicationKeys.base, "detail"] as const,
  detail: (applicationId?: string) =>
    [...projectApplicationKeys.details(), applicationId] as const,
};

export { artistApplicationKeys, projectApplicationKeys };
